
export default function Footer() {
    return (
        <div>
            <footer className="footer">
                <p>&copy; Reserved by @divyatailang {new Date().getFullYear()}</p>
            </footer>
        </div>
    )
}
